export default __webpack_public_path__ + "static/media/PedroH.559b6932.png";